"use client";

import { useState, useEffect } from "react";
import Slider from "react-slick";
import BrandArrow from "../ui/BrandArrow";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Camera } from "lucide-react";
import { supabase } from "../../Supabase/SupabaseClient";
import "./Review.css";

// ── flechas custom, mismo patrón que Carrousel.js ──
const PrevArrow = ({ onClick }) => (
  <button
    type="button"
    className="photo-review-arrow photo-review-arrow--prev"
    onClick={onClick}
    aria-label="Anterior"
  >
    <BrandArrow />
  </button>
);

const NextArrow = ({ onClick }) => (
  <button
    type="button"
    className="photo-review-arrow photo-review-arrow--next"
    onClick={onClick}
    aria-label="Siguiente"
  >
    <BrandArrow direction="up-right" />
  </button>
);

const PhotoReviewCarousel = () => {
  const [reviews, setReviews] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [newRating, setNewRating] = useState(5);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      setUser(session?.user ?? null);
    });
    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  const fetchReviews = async () => {
    const { data, error } = await supabase
      .from("reseñas")
      .select("*")
      .order("createdAt", { ascending: false });
    if (error) {
      console.error("Error al obtener las reseñas:", error);
    } else {
      setReviews(data);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user || newComment.trim() === "") return;

    const newReview = {
      author: user.user_metadata?.full_name || user.email,
      content: newComment,
      rating: Number(newRating),
      image: user.user_metadata?.avatar_url || "/placeholder.svg",
      createdAt: new Date().toISOString(),
    };

    const { error } = await supabase.from("reseñas").insert([newReview]);
    if (error) {
      console.error("Error al enviar la reseña:", error);
    } else {
      fetchReviews();
      setNewComment("");
      setNewRating(5);
    }
  };

  const signInWithGoogle = async () => {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
    });
    if (error) {
      console.error("Error al iniciar sesión con Google:", error);
    }
  };

  const settings = {
    dots: false,
    infinite: reviews.length > 3,
    speed: 450,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="photo-review-container">
      <h2 className="photo-review-main-titles">Testimonios</h2>

      {reviews.length > 0 && (
        <div className="photo-review-slider-wrap">
          <Slider {...settings}>
            {reviews.map((review) => (
              <div key={review.id} className="photo-review-slide">
                <div
                  className="photo-review-card"
                  style={{ backgroundImage: `url(${review.image || "/placeholder.svg"})` }}
                >
                  <span className="photo-review-corner photo-review-corner--tl" aria-hidden="true" />
                  <span className="photo-review-corner photo-review-corner--tr" aria-hidden="true" />
                  <span className="photo-review-corner photo-review-corner--bl" aria-hidden="true" />
                  <span className="photo-review-corner photo-review-corner--br" aria-hidden="true" />

                  <div className="photo-review-quote-box">
                    <p className="photo-review-body">&ldquo;{review.content}&rdquo;</p>
                    <span className="photo-review-authors">{review.author}</span>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}

      {!user ? (
        <button onClick={signInWithGoogle} className="photo-review-login-button">
          Inicia sesión para dejar tu reseña
        </button>
      ) : (
        <div className="photo-review-form-container">
          <h3 className="photo-review-form-titles">
            <Camera className="photo-review-camera-icon" /> Comparte tu Experiencia
          </h3>
          <form onSubmit={handleSubmit} className="photo-review-form">
            <div className="photo-review-form-group">
              <label htmlFor="comment">Tu Comentario</label>
              <textarea
                id="comment"
                placeholder="Cuéntanos sobre tu experiencia..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                rows={4}
                required
              ></textarea>
            </div>
            <div className="photo-review-form-group">
              <label htmlFor="rating">Calificación</label>
              <select
                id="rating"
                value={newRating}
                onChange={(e) => setNewRating(Number(e.target.value))}
              >
                {[1, 2, 3, 4, 5].map((num) => (
                  <option key={num} value={num}>
                    {num} {num === 1 ? "Estrella" : "Estrellas"}
                  </option>
                ))}
              </select>
            </div>
            <button type="submit" className="photo-review-submit-button">
              Enviar Reseña
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default PhotoReviewCarousel;